export const AuthStateEnum = Object.freeze({
	STARTING: 'starting',
	SIGNED_OUT: 'signedOut',
	BUSY: 'busy',
	READY: 'ready',
	ERROR: 'error',
})
